const createHTMLMapMarker = ({
    OverlayView = google.maps.OverlayView,
    ...args
}) => {

    class HTMLMapMarker extends OverlayView {
        constructor() {
            super();
            this.latlng = args.latlng;
            this.html = args.html;
            this.setMap(args.map);

            this.divWidth = "30px";
            this.divHeight = "16px";
            this.color = args.color;
            this.click = args.click;
            this.selected = args.selected;
            this.fade = args.fade;
            this.zIndex = args.zIndex;
        }


        createDiv() {
            this.div = document.createElement("div");
            this.div.style.position = "absolute";
            this.div.style.width = this.divWidth;
            this.div.style.height = this.divHeight;
            this.div.style.backgroundColor = this.color;
            // this.div.style.borderRadius = "6px";
            this.div.style.paddingTop = "1px";
            this.div.style.border = "1px solid black"

            // this.div.style.filter = "brightness(92%)";

            var newColor = this.color;

            if (this.selected == true) {
                this.div.style.webkitTransform = 'translateZ(-10px)';
                this.div.style.backgroundColor = "#000000";
                this.div.style.color = "#ffffff";
                newColor = "#000000"
                this.div.style.zIndex = 5;
            } else {
                this.div.style.webkitTransform = 'translateZ(0px)';
                this.div.style.zIndex = this.zIndex;
            }

            if (!this.selected && this.fade) {
                this.div.style.opacity = 0.3;
            }

            if (this.html) {
                this.div.innerHTML = this.html + "<div class='triangle' style='margin-left: 7px; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-top: 12px solid " + 'black' + ";'></div>";
            }


            var me = this;
            var click = this.click;

            google.maps.event.addDomListener(this.div, "click", event => {
                click();
                google.maps.event.trigger(me, "click");
            });
        }

        appendDivToOverlay() {
            this.getPanes().overlayMouseTarget.appendChild(this.div);
        }

        positionDiv() {
            const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
            if (point) {
                this.div.style.left = `${point.x - 15}px`;
                this.div.style.top = `${point.y - 20}px`;
            }
        }

        draw() {

            if (!this.div) {
                this.createDiv();
                this.appendDivToOverlay();
            }
            this.positionDiv();
        }

        remove() {

            this.setMap(null);

            if (this.div) {
                this.div.parentNode.removeChild(this.div);
                this.div = null;
            }
        }

        getPosition() {
            return this.latlng;
        }

        getDraggable() {
            return false;
        }
    }

    return new HTMLMapMarker();

}

export default createHTMLMapMarker;